import errorManager from '@/rollbar.js';

const setObserver = (selectors) => {
  try {
    const disableSelectAllCheckbox = (data) => {
      if (data.length == 0) {
        $(selectors.select_all_guests).attr('disabled', true);
      } else {
        $(selectors.select_all_guests).removeAttr('disabled');
      }
    };

    const updateGuestSelect = (data) => {
      $(selectors.target_id).empty().trigger('change');
      let mapped_data = data.map((result) => {
        return { id: result.id, text: result.label };
      });
      $(selectors.target_id).select2({
        theme: 'bootstrap',
        data: mapped_data,
      });
    };

    const getAjaxData = (selected_bu_ids) => {
      let request_guest_url = new URL($(selectors.select_id)[0].dataset.baseUrl);
      request_guest_url.searchParams.append('selected_ids', selected_bu_ids);
      $.ajax({
        url: request_guest_url,
        dataType: 'json',
        success: function (data) {
          window.SelectGuestBusinessUnitsFilter.globalData = data;
          disableSelectAllCheckbox(data);
          updateGuestSelect(data);
        },
      });
    };

    const selectAll = () => {
      $(selectors.target_id).select2({ theme: 'bootstrap' });
      if ($(selectors.select_all_guests).is(':checked')) {
        $(`${selectors.target_id} > option`).prop('selected', 'selected');
        $(`${selectors.target_id}`).trigger('change');
      } else {
        $(`${selectors.target_id} > option`).removeAttr('selected');
        $(`${selectors.target_id}`).trigger('change');
      }
    };

    $(selectors.select_id).on('change.select2', function () {
      let selected_bu_ids = $(selectors.select_id)
        .select2('data')
        .map((selection) => {
          return selection.id;
        });
      getAjaxData(selected_bu_ids);
    });

    $(selectors.target_id).on('change', function () {
      if (window.SelectGuestBusinessUnitsFilter.globalData.length != $(selectors.target_id).select2('data').length) {
        $(selectors.select_all_guests).prop('checked', false);
      }
    });

    $(selectors.select_all_guests).click(selectAll);

    getAjaxData(selectors.init_params);
  } catch (e) {
    console.error(e);
  }
};

const init = (selectors) => {
  try {
    setObserver(selectors);
  } catch (e) {
    errorManager(e);
  }
};

window.SelectGuestBusinessUnitsFilter = {
  init: init,
  globalData: null,
};
